export type PylonScopeOrMethod = string

export const PylonApi = (method: PylonScopeOrMethod, ...args: Array<unknown>) => {
  if (typeof window !== 'undefined' && typeof window.Pylon === 'function') {
    return (window as any).Pylon.apply(null, [method, ...args])
  }
}
